import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { H2, LargeOnly, Loading } from "commons";
import { IN_PROGRESS, isInProgress } from "commons/src/helpers/RequestHelpers";
import { convertToMoney } from "commons/src/Money";

import { requestObject } from "../../reducers/requestsActions";
import { ValVsMimo } from "../../routes/Analysis/ValVsMimo";
import { CaretIcon } from "./components";
import { routes } from "../../helpers/RouteHelpers";

export function PortfolioTotalBlock({
    value,
    requestStatus: { status = IN_PROGRESS },
    analysis,
    accounts
}) {
    const content = value || value === 0 ? <span>{convertToMoney(value)}</span> : null;

    return (
        <Container>
            <LargeOnly>
                <H2 secondary margin="0 0 1rem 0">
                    My portfolio
                </H2>
            </LargeOnly>
            <Content>
                <StyledLink
                    to={routes.client.folioDetails({ accountNum: "Combined" })}
                    data-testid="portfolio-details-link"
                >
                    <FolioTotal>
                        <TotalText height="2em">Portfolio total</TotalText>

                        <TotalText height="2em">
                            <Loading displayWhen={!!content} size={15} colour="white">
                                {content}
                            </Loading>
                        </TotalText>
                        <CaretIcon size="large" />
                    </FolioTotal>
                </StyledLink>

                <FolioGraph data-testid="portfolio-details-graph">
                    <Loading
                        displayWhen={!isInProgress(status)}
                        size={30}
                        colour="white"
                        data-testid="folio-graph-loading"
                    >
                        <ValVsMimo
                            account="Combined"
                            data={analysis}
                            isHome={true}
                            selectedAccounts={accounts}
                        />
                    </Loading>
                </FolioGraph>
            </Content>
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const Content = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledLink = styled(Link)`
    width: 49%;

    @media (max-width: ${props => props.theme.maxWidth}) {
        width: 100%;
    }
`;

const FolioTotal = styled.div`
    background: ${props => props.theme.primary};
    color: ${props => props.theme.tertiary};
    align-items: center;
    position: relative;
    width: 100%;

    @media (min-width: ${props => props.theme.minWidth}) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 350px;
        font-size: 2em;
    }

    @media (max-width: ${props => props.theme.maxWidth}) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 54px;
        padding: 14px 28px 14px 14px;
    }
`;

const FolioGraph = styled.div`
    width: 49%;
    background: ${props => props.theme.primary};
    color: ${props => props.theme.tertiary};
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: ${props => props.theme.maxWidth}) {
        display: none;
    }
`;

const TotalText = styled.div`
    font-size: 1.4em;
`;

PortfolioTotalBlock.propTypes = {
    accounts: PropTypes.object,
    analysis: PropTypes.object,
    value: PropTypes.number,
    requestStatus: requestObject
};
